import { useAudience } from '../app/contexts/AudienceContext';
import { SWAP_MAP } from '../app/constants/audienceSwapMap';

/**
 * Returns the audience-swapped value for a given slot, or the fallback
 * (current default copy) when no audience is active.
 */
export function useAudienceCopy(slotId: string, fallback: string): string {
  const { audience } = useAudience();

  if (!audience) return fallback;

  const slot = SWAP_MAP[audience]?.[slotId];
  if (!slot) return fallback;

  return slot.replacement;
}
